import { render, staticRenderFns } from "./symptomDetail.vue?vue&type=template&id=a3ffbbdc&scoped=true"
import script from "./symptomDetail.vue?vue&type=script&lang=js"
export * from "./symptomDetail.vue?vue&type=script&lang=js"
import style0 from "./symptomDetail.vue?vue&type=style&index=0&id=a3ffbbdc&prod&scoped=true&lang=css"
import style1 from "./symptomDetail.vue?vue&type=style&index=1&id=a3ffbbdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ffbbdc",
  null
  
)

export default component.exports